// extracted by mini-css-extract-plugin
export default {"connectivity-form":"ActiveDirectoryForm_connectivity-form__5Xsvt","alignment":"ActiveDirectoryForm_alignment__NSaYo"};